import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
  Paper,
} from '@mui/material';

interface Props {
  applicationId: string;
}

const STATUS_LABELS: Record<string, string> = {
  success: '성공',
  failure: '실패',
};

const AlertSendHistory = ({ applicationId }: Props) => {
  const [logs, setLogs] = useState<any[]>([]);

  useEffect(() => {
    const q = query(
      collection(db, 'alerts_log'),
      where('application_id', '==', applicationId)
    );
    const unsubscribe = onSnapshot(q, (snap) => {
      const result = snap.docs
        .map((doc) => doc.data())
        .filter((log) => log.sent_at)
        .sort((a, b) => b.sent_at?.seconds - a.sent_at?.seconds);
      setLogs(result);
    });
    return () => unsubscribe();
  }, [applicationId]);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography
        variant="subtitle1"
        fontWeight={700}
        sx={{ color: '#1976d2', mb: 1 }}
      >
        최근 전송 이력
      </Typography>
      <Paper
        elevation={0}
        sx={{
          p: 0,
          background: '#f9fafc',
          borderRadius: 2,
          border: '1.2px solid #e0e7ef',
          boxShadow: 'none',
        }}
      >
        <List dense sx={{ p: 0 }}>
          {logs.length === 0 && (
            <ListItem>
              <ListItemText
                primary={<Typography color="text.secondary">이력이 없습니다.</Typography>}
              />
            </ListItem>
          )}
          {logs.map((log, idx) => (
            <ListItem
              key={idx}
              sx={{
                px: 2,
                py: 1.1,
                borderBottom:
                  idx !== logs.length - 1 ? '1px solid #f0f0f4' : undefined,
                bgcolor: log.status === 'failure' ? '#fff8f8' : undefined,
                alignItems: 'flex-start',
              }}
              disableGutters
              secondaryAction={
                <Chip
                  label={STATUS_LABELS[log.status] || log.status}
                  size="small"
                  sx={{
                    bgcolor:
                      log.status === 'success' ? '#43a047' : '#ef5350',
                    color: '#fff',
                    fontWeight: 700,
                    px: 1.2,
                    letterSpacing: '-0.5px',
                    fontSize: 13,
                    borderRadius: 1.5,
                  }}
                />
              }
            >
              <ListItemText
                primary={
                  <Typography fontWeight={600} color="#222" sx={{ fontSize: 15 }}>
                    {log.event || '-'}
                  </Typography>
                }
                secondary={
                  <Typography
                    fontSize={13}
                    color="#888"
                    sx={{ mt: 0.2, fontWeight: 500, letterSpacing: '-0.5px' }}
                  >
                    {log.sent_at?.toDate?.().toLocaleString() || '시간 미상'}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default AlertSendHistory;
